import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import loginRequest from './utils/LoginRequest'
import webRequest from './utils/WebRequest'
import commonFn from './utils/common'

import './assets/css/public.css'


Vue.prototype.$loginRequest = loginRequest
Vue.prototype.$webRequest = webRequest
Vue.prototype.$commonFn = commonFn
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
